import React from 'react';
import { useParams, useOutletContext, useLocation } from 'react-router-dom';
import ClubManagement from '../ClubManagement';

/**
 * ProfileClubManagement - Club management page accessible from profile flow
 * Route: /profile/clubs/:clubId/manage
 * Only accessible to admins/hosts/owners
 * 
 * This is a thin wrapper around ClubManagement that passes navigation state
 * so ClubManagement knows to navigate back to the profile flow
 */
const ProfileClubManagement = () => {
  const { currentUser } = useOutletContext();
  const { clubId } = useParams();
  const location = useLocation();

  // Pass navigation state to ClubManagement so it knows we came from profile
  // We'll use replace to inject the state, but ClubManagement will read it from location.state
  // Since we can't modify location.state directly, we'll rely on ClubManagement
  // checking the route path or we can pass it via a wrapper
  
  // ClubManagement will handle its own permission checking and UI
  // It uses useParams to get clubId, so that will work automatically
  // We just need to ensure it knows to navigate back to profile
  
  return <ClubManagement currentUser={currentUser} />;
};

export default ProfileClubManagement;

